import {Component} from '@angular/core';
import {ProfileCompletionService} from '../../domain/model/completion/profile-completion.service';
import {noop} from '../../common/functions/functions.util';
import {DashboardProfileCompletion} from './model/profile-completion.model';
import {Roles} from '../../domain/authorization/roles';

@Component({
    template: require('./dashboard-page.component.html'),
    styles: [require('./dashboard-page.component.scss')]
})
export class DashboardPageComponent {
    model?: DashboardProfileCompletion;
    activeSection?: string;
    noop = noop;
    Roles = Roles;

    constructor(private readonly _profileCompletionService: ProfileCompletionService) {
        this._profileCompletionService.getCurrentUserModel().subscribe(it => {
            if (it) this.model = new DashboardProfileCompletion(it);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/dashboard/dashboard-page.component.ts